import type { Model } from '@thevillages/schemas';

import { untracked } from '@angular/core';

import type { FilteringService } from '.';

export function RelatedModels(this: FilteringService): Model[] {
  if (!this.models().length && !this.searchModels().length) {
    return [];
  }

  const _availableModels = this.availableModels.value();
  if (!_availableModels) {
    return [];
  }

  const _output = [];

  if (this.searchModels().length > 0) {
    for (const _term of this.searchModels()) {
      const _searchedModels = _availableModels.filter((m) => m.id.includes(_term));
      for (const _model of _searchedModels) {
        if (_model.relatedModels && _model.relatedModels.length > 0) {
          for (const _relatedModelId of _model.relatedModels) {
            const _relatedModel = _availableModels.find((m) => m.id === _relatedModelId);
            if (_relatedModel) {
              _output.push(_relatedModel);
            }
          }
        }
      }
    }

    untracked(() => {
      this.searchModels.set([]);
    });
  } else if (this.models().length > 0) {
    for (const _model of this.models()) {
      const _matchedModels = _availableModels.filter((m) => m.id.includes(_model));

      if (_matchedModels.length < 1) {
        continue;
      }

      for (const _modelDetails of _matchedModels) {
        if (!_modelDetails.relatedModels || _modelDetails.relatedModels.length === 0) {
          continue;
        }

        for (const _relatedModelId of _modelDetails.relatedModels) {
          const _relatedModel = _availableModels.find((m) => m.id === _relatedModelId);
          if (_relatedModel) {
            _output.push(_relatedModel);
          }
        }
      }
    }
  }

  return _output;
}
